import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BlogCard from '../components/BlogCard';
import Error from '../components/Error';
import Loader from '../components/Loader';
import Sidebar from '../components/Sidebar';
import { fetchBlogs } from '../features/blogs/blogsSlice';

const HomePage = () => {
  const dispatch = useDispatch();
  const { blogs, isLoading, isError, error } = useSelector(
    (state) => state.blogs
  );

  const { sort, filter } = useSelector((state) => state.filters);

  useEffect(() => {
    dispatch(fetchBlogs({ sort, filter }));
  }, [dispatch, sort, filter]);

  // decide what to render
  let content = null;

  if (isLoading) content = <Loader />;

  if (!isLoading && isError) content = <Error msg={error} />;

  if (!isError && !isLoading && blogs?.length === 0) {
    content = <div className="col-span-12">No Blogs Found!</div>;
  }

  if (!isError && !isLoading && blogs?.length > 0) {
    content = blogs.map((blog) => <BlogCard key={blog.id} blog={blog} />);
  }

  return (
    <section className="wrapper">
      <Sidebar />
      <main className="post-container" id="lws-postContainer">
        {content}
      </main>
    </section>
  );
};

export default HomePage;
